<template>
<div class="main-wrapper">
  <layout-header />
  <layout-sidebar />

  <a-spin :spinning="isDataLoading">
  <div class="page-wrapper">
    <div class="content container-fluid scheduler-wrapper">

		<shift-header
          :title="title"
          :path="path"
          :text="text"
          :text1="text1"
          :text2="text2"
          :text3="text3"
          :text4="text4"
          :search_data="searchData2"
          :columns="columns"
          :current-week-start="currentWeekStart"
          :current-week-end="currentWeekEnd"
          @add-shift="openAddShiftModel"
          @add-schedule="openAddScheduleModel"
          @add-dept-schedule="openAddDeptScheduleModel"
          @copy-week="handleCopyWeek"
        />
		
		<shift-scheduling-filter
          :hasEditPermission="hasEditPermission"
          @search-schedule="searchSchedule"
          :sDate="sDate"
          :eDate="eDate"
        />
		
		
      <div class="scheduler-table-wrapper">

		<div class="scheduler-scroll">
		
			<!-- PALETTE -->
			
			<!--
			<div class="palette-fixed">
			  <div ref="palette" class="palette-row">
				<div
				  v-for="s in shifts"
				  :key="s.shift_id"
				  class="shift-box"
				  :style="{ background: assignShiftBGColor(s.shift_id) }"
				  :data-id="s.shift_id"
				>
				  <b>{{ s.shift_name }}</b>
				  <small>{{ s.start_time }} - {{ s.end_time }}</small>
				</div>
			  </div>
			</div> -->
			
			
			<!-- PALETTE -->
			<div class="palette-strip">
			  <div ref="palette" class="palette-inner">
				<div
				  v-for="s in shifts"
				  :key="s.shift_id"
				  class="shift-box"
				  :data-id="s.shift_id"
				  :style="{ background: assignShiftBGColor(s.shift_id) }"
				>
				  <div class="shift-title">{{ s.shift_name }} {{ hasEditPermission }}</div>
				  <div class="shift-time">
					{{ s.start_time }} - {{ s.end_time || 'Not Set' }}
				  </div>
				</div>

			  </div>
			</div>






			<!-- GRID -->
        

          <div class="grid" :style="{ gridTemplateColumns: gridTemplateColumns }">
            <div class="cell head emp">Employee</div>
            <div class="cell head" v-for="d in dates" :key="d">
              {{ formatDay(d) }}
            </div>
          </div>

          <div
            class="grid row"
            v-for="emp in scheduleData"
            :key="emp.id"
            :style="{ gridTemplateColumns: gridTemplateColumns }"
          >
            <div class="cell emp">
              <h2 class="table-avatar">
                <router-link :to="'/profile/' + emp?.id" class="avatar">
                  <img
                    v-if="emp?.avatar && emp?.avatar != null"
                    :src="getEmployeeAvatar(emp?.avatar)"
                    alt="User Image"
                    @error="handleImageError(emp)"
                  />
                  <img
                    v-else
                    :src="require(`@/assets/img/profiles/${defaultAvatar}`)"
                    alt="User Image"
                  />
                </router-link>
                <router-link :to="'/profile/' + emp?.id">
                  {{ emp.first_name }} {{ emp.last_name }}
                </router-link>
              </h2>
            </div>

            <div
              v-for="d in dates"
              :key="d"
              class="cell drop-cell"
              :ref="el => registerCell(el, emp.id, d)"
			  data-bs-toggle="modal"
			  data-bs-target="#add_schedule"
			  @click="hasCreatePermission && !isDataLoading && onAddSchedule(emp.id, d, emp.emp_department_id)"
            >
              <div
                v-for="a in emp[d]"
                :key="a.schedule_id"
                class="assigned"
				:data-shift-id="a.shift_id"
				data-bs-toggle="modal"
				data-bs-target="#add_schedule"
                :style="{ background: assignShiftBGColor(a.shift_id) }"
				@click.stop="hasEditPermission && !isDataLoading && onEditSchedule(a)"
              >
                <div class="assigned-title">
                  {{ a.shift?.shift_name }}
                </div>
                <div class="assigned-time">
                  {{ a.shift?.start_time }} - {{ a.shift?.end_time }}
                </div>
              </div>
            </div>

          </div>

        </div>
      </div>

      <!-- Pagination Controls -->
      <div class="row mt-3">
        <div class="col-md-12">
          <div class="showentries mb-3">
            <label>
              Show
              <select v-model.number="pagination.pageSize" @change="updatePerPage">
                <option :value="10">10</option>
                <option :value="25">25</option>
                <option :value="50">50</option>
                <option :value="100">100</option>
              </select>
              entries
            </label>
          </div>
          <a-pagination
            v-model:current="pagination.current"
            :page-size="pagination.pageSize"
            :total="pagination.total"
            :show-size-changer="false"
            :show-total="(total, range) => `${range[0]}-${range[1]} of ${total} items`"
            @change="(page, pageSize) => handleTableChange({ current: page, pageSize: pageSize })"
            class="mt-2"
          />
        </div>
      </div>
      <!-- /Pagination Controls -->
    </div>
	<teleport to="body">

  <shift-list-model
    @delete-shift="deleteShift"
    :deleteId="deleteID"
    :editShift="editShift"
    :closeModal="closeModal"
  />

  <edit-schedule-model
    :addEmployeeId="addEmployeeId"
    :editSchedule="editSchedule"
    @add-schedule="openAddScheduleModel"
    @reload-data="reloadData"
  />

  <dept-schedule-model
    @add-dept-schedule="openAddDeptScheduleModel"
    @reload-data="reloadData"
  />

</teleport>

  
  </div>
  </a-spin>

</div>
</template>

<script>
import Sortable from "sortablejs";
import axios from "axios";
import moment from "moment";
import { notification } from "ant-design-vue";

export default {
data(){
  return {
	sDate: null,
    eDate: null,
	showEditModal:false,
	showDeptModal:false,
	showShiftModal:false,
	searchData2: null,
    columns: [],
	currentWeekStart: null,
    currentWeekEnd: null,
    shifts: [],
    scheduleData: [],
    dates: [],
    startDayOfWeek: "Monday",
    isDataLoading: false,
	hasCreatePermission:true,
    hasEditPermission:true,
    title:"Daily Scheduling",
	path:"Dashboard",
	  text:"Employees",
	  text1:"Shift Scheduling",
	  text2:"Shifts",
	  text3:"Assign Shifts",
	  text4:"Assign Department Shifts",
	  addEmployeeId:null,
editSchedule:null,
deleteID:null,
editShift:null,
closeModal:false,
pagination: { total: 0, current: 1, pageSize: 10 },
searchData: null,
defaultAvatar: "avatar-01.jpg",
dayWidth: 200,

	
  }
},
mounted(){
  this.fetchWeekDay();
  this.$nextTick(() => {
    this.initPalette();
  });
},
watch:{
  addEmployeeId(v){
    if(v){
      this.$nextTick(()=> this.addEmployeeId = this._forceModal(v));
    }
  },
  editSchedule(v){
    if(v){
      this.$nextTick(()=> this.editSchedule = this._forceModal(v));
    }
  },
  editShift(v){
    if(v){
      this.showShiftModal = false;
      this.$nextTick(()=> this.showShiftModal = true);
    }
  }
},

methods:{
_force(obj){
  return JSON.parse(JSON.stringify(obj));
},
_forceModalRefresh(){
  this.addEmployeeId = null;
  this.editSchedule = null;
},

_forceModal(obj){
  return { ...obj, __force: Date.now() };
},
searchSchedule(params) {
  this.searchData = params;
  this.searchData2 = params;
  this.fetchScheduleData(params);
},
async handleCopyWeek(targetWeek){

  const payload = {
    current_week_start: this.currentWeekStart,
    current_week_end: this.currentWeekEnd,
    target_week_start: targetWeek.startDate,
    target_week_end: targetWeek.endDate,
  };

  let loader = this.$loading.show({ container:this.$el });

  try{
    const res = await axios.post("schedule/copy-schedules", payload);
    await this.reloadData(false);

    notification.open({
      message: res.data.message || "Week copied successfully",
      placement: "topRight",
      duration: process.env.VUE_APP_NOTIFICATION_DURATION,
      style: { background: process.env.VUE_APP_SUCCESS_COLOR }
    });

  }catch(error){

    const r = error.response;
    notification.open({
      message: r?.data?.message || "Failed to copy week",
      placement: "topRight",
      duration: process.env.VUE_APP_NOTIFICATION_DURATION,
      style: { background: process.env.VUE_APP_WARNING_COLOR }
    });

  }finally{
    loader.hide();
  }
},


calculateWeekDates(){
  let startDate = moment();
  while (startDate.format("dddd") !== this.startDayOfWeek) {
    startDate.subtract(1, "day");
  }
  return {
    currentWeekStart: startDate.format("YYYY-MM-DD"),
    currentWeekEnd: moment(startDate).add(6, "days").format("YYYY-MM-DD"),
  };
},

setCurrentWeekDates(){
  const { currentWeekStart, currentWeekEnd } = this.calculateWeekDates();
  this.currentWeekStart = currentWeekStart;
  this.currentWeekEnd = currentWeekEnd;
},

openAddShiftModel(){
  this.editShift = null;
},

openAddScheduleModel(){
  this.addEmployeeId = null;
  this.editSchedule = null;
},

openAddDeptScheduleModel(){
  this.editSchedule = null;
},

deleteShift(id){
  this.deleteID = id;
},

onAddSchedule(empId, date, deptId){
  this.addEmployeeId = null;
  this.$nextTick(()=>{
    this.addEmployeeId = this._force({ id: empId, date, department_id: deptId });
  });
},

onEditSchedule(schedule){
  this.editSchedule = null;
  this.$nextTick(()=>{
    this.editSchedule = this._force(schedule);
  });
},

async fetchWeekDay(){
  let token = localStorage.getItem("token");
  axios.defaults.headers.common.Authorization = "Bearer "+token;

  const r = await axios.get("/globalsettings/shiftsettings");
  const v = r.data.data.find(i=>i.global_settings_key==="start_day_of_week");
  this.startDayOfWeek = v?.global_settings_value || "Monday";
  this.setCurrentWeekDates();

  this.buildDates();
  await this.getAllShiftList();
  this.fetchScheduleData();
},

buildDates(){
  let s = moment();
  while(s.format("dddd")!==this.startDayOfWeek) s.subtract(1,"day");
  this.dates=[];
  for(let i=0;i<7;i++){
    this.dates.push(s.format("YYYY-MM-DD"));
    s.add(1,"day");
  }
},

async getAllShiftList(){
  const r = await axios.get("shifts/all");
  this.shifts = r.data.data || [];
},

async fetchScheduleData(pagesize = null, showLoader = true){
  var token = window.localStorage.getItem("token");
  axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
  axios.defaults.headers.common["Authorization"] = "Bearer " + token;

  // Handle case where pagesize is a boolean (legacy signature: fetchScheduleData(showLoader))
  if (pagesize === true || pagesize === false) {
    showLoader = pagesize;
    pagesize = null; // Reset to null so we use searchData below
  }

  // Determine start_date and end_date
  let start_date = null;
  let end_date = null;

  // Priority: pagesize object > searchData > default week
  if (pagesize && typeof pagesize === 'object' && pagesize.start_date && pagesize.end_date) {
    start_date = pagesize.start_date;
    end_date = pagesize.end_date;
  } else if (this.searchData && this.searchData.start_date && this.searchData.end_date) {
    start_date = this.searchData.start_date;
    end_date = this.searchData.end_date;
  } else {
    // Default to current week
    let start = moment();
    while (start.format("dddd") !== this.startDayOfWeek) {
      start.subtract(1, "day");
    }
    start_date = start.format("YYYY-MM-DD");
    end_date = moment(start_date).add(6, "days").format("YYYY-MM-DD");
  }

  var params = {
    params: {
      per_page: this.pagination.pageSize,
      page: this.pagination.current,
      start_date: start_date,
      end_date: end_date,
    },
  };

  // If pagesize is an object with pagination/filter data
  if (pagesize && typeof pagesize === 'object') {
    // Handle pagination - prioritize pageSize/current over per_page/page
    if (pagesize?.pageSize != null) {
      params.params.per_page = pagesize.pageSize;
    } else if (pagesize?.per_page != null) {
      params.params.per_page = pagesize.per_page;
    }

    if (pagesize?.current != null) {
      params.params.page = pagesize.current;
    } else if (pagesize?.page != null) {
      params.params.page = pagesize.page;
    }

    // Handle filter parameters
    if (pagesize?.employee_id != null) {
      params.params.employee_id = pagesize.employee_id;
    }

    if (pagesize?.department_id != null) {
      params.params.department_id = pagesize.department_id;
    }

    if (pagesize?.start_date != null) {
      params.params.start_date = pagesize.start_date;
    }

    if (pagesize?.end_date != null) {
      params.params.end_date = pagesize.end_date;
    }
  }

  // If no pagesize object but we have searchData, merge it (but don't override dates if already set)
  if (!pagesize && this.searchData) {
    Object.keys(this.searchData).forEach(key => {
      if (key !== 'start_date' && key !== 'end_date') {
        params.params[key] = this.searchData[key];
      } else if (!params.params[key]) {
        params.params[key] = this.searchData[key];
      }
    });
  }

  // Update dates if start_date or end_date are provided
  if (params.params.start_date && params.params.end_date) {
    this.buildDatesFromRange(params.params.start_date, params.params.end_date);
  }

  this.isDataLoading = true;
  let loader = null;
  if (showLoader) {
    loader = this.$loading.show({
      container: this.$el,
      canCancel: false,
    });
  }

  this.searchData2 = params.params;

  try {
    const r = await axios.get("schedule/list", params);
    
    if (r.status == 200) {
      const responseData = r?.data?.data || r?.data || {};
      
      // Update pagination from response
      this.pagination.total = responseData.total || 0;
      this.pagination.current = responseData.current_page || responseData.page || params.params.page || 1;
      this.pagination.pageSize = responseData.per_page || params.params.per_page || this.pagination.pageSize;

      // Get schedule data
      if (responseData.data && Array.isArray(responseData.data)) {
        this.scheduleData = responseData.data;
      } else if (Array.isArray(responseData)) {
        this.scheduleData = responseData;
      } else {
        this.scheduleData = [];
      }
    }
  } catch (error) {
    console.log("schedule error");
    console.log(error);
    var response = error?.response;

    this.scheduleData = [];

    if (
      response &&
      response.status == 401 &&
      response.data?.message == "Unauthenticated."
    ) {
      localStorage.clear();

      notification.open({
        message: "Please Login",
        placement: "topRight",
        duration: process.env.VUE_APP_NOTIFICATION_DURATION,
        style: {
          background: process.env.VUE_APP_WARNING_COLOR,
        },
      });

      this.$router.push({ name: "login" }).catch((error) => {});
    } else {
      notification.open({
        message: response?.data?.message || error?.message || "Error fetching schedule data",
        placement: "topRight",
        duration: process.env.VUE_APP_NOTIFICATION_DURATION,
        style: {
          background: process.env.VUE_APP_WARNING_COLOR,
        },
      });
    }
  } finally {
    if (loader) loader.hide();
    this.isDataLoading = false;
  }
},

assignShiftBGColor(id){
  const colors = ["#FF0000","#0000FF","#FF00FF","#808000","#8B4513","#F82F72"];
  return colors[id % colors.length] + "2a";
},

formatDay(d){
  return moment(d).format("ddd D");
},

getEmployeeAvatar(avatar) {
  return `${process.env.VUE_APP_IMAGE_BASE_URL}${avatar}`;
},

handleImageError(record) {
  record.avatar = null;
  record.avatar = `assets/img/profiles/${this.defaultAvatar}`;
},

buildDatesFromRange(startDate, endDate){
  let s = moment(startDate);
  const e = moment(endDate);
  this.dates = [];
  while(s.isSameOrBefore(e, 'day')){
    this.dates.push(s.format("YYYY-MM-DD"));
    s.add(1, "day");
  }
  // Update sDate and eDate for the filter component
  this.sDate = moment(startDate);
  this.eDate = moment(endDate);
},

handleTableChange(pagesize) {
  // Preserve searchData but override with pagination params
  const mergeObj = { 
    ...this.searchData, 
    ...pagesize,
    pageSize: pagesize.pageSize || pagesize.per_page || this.pagination.pageSize,
    current: pagesize.current || pagesize.page || this.pagination.current
  };
  this.fetchScheduleData(mergeObj);
},

updatePerPage() {
  // Reset to page 1 when changing page size
  var params = { 
    pageSize: this.pagination.pageSize,
    current: 1,
    ...this.searchData 
  };
  this.fetchScheduleData(params);
},

async reloadData(showLoader = true) {
  await this.fetchScheduleData(this.searchData, showLoader);
  this.$nextTick(() => {
    this.initPalette();
  });
},

initPalette(){
  if(!this.$refs.palette || this.$refs.palette._sortable) return;
  this.$refs.palette._sortable = true;

  Sortable.create(this.$refs.palette, {
    group: { name: "shifts", pull: "clone", put: false },
    sort: false,
    animation: 150
  });
},

registerCell(el, emp, date){
  if(!el || el._sortable) return;
  el._sortable = true;

  Sortable.create(el, {
    group: "shifts",
    animation: 180,
    onAdd: evt => this.onDrop(evt, emp, date)
  });
},


async onDrop(evt, emp, date){
  const fromCell = evt.from;
  const toCell = evt.to;

  let shift_id = null;
  let movedSchedule = null;

  // palette → cell
  if (evt.from === this.$refs.palette) {
    shift_id = +evt.item.dataset.id;
  }
  // cell → cell
  else {
    shift_id = +evt.item.getAttribute("data-shift-id");
  }

  evt.item.remove();

  const record = this.scheduleData.find(e => e.id === emp);
  if (!record) return;
  
  record[date] ||= [];

  // Find source employee+date if cell→cell
  let sourceRecord = null, sourceDate = null;
  if (evt.from !== this.$refs.palette) {
    for (const r of this.scheduleData) {
      for (const d of this.dates) {
        if (r[d]?.some(s => s.shift_id === shift_id)) {
          sourceRecord = r;
          sourceDate = d;
          break;
        }
      }
      if (sourceRecord) break;
    }
    if (sourceRecord && sourceDate) {
      movedSchedule = sourceRecord[sourceDate].find(s => s.shift_id === shift_id);
      if (movedSchedule) {
        sourceRecord[sourceDate] = sourceRecord[sourceDate].filter(s => s.shift_id !== shift_id);
      }
    }
  }

  if (record[date].some(s => s.shift_id === shift_id)) return;

  const shift = movedSchedule || this.shifts.find(s => s.shift_id === shift_id);
  if (!shift) return;

  const newSchedule = {
    shift_id: shift.shift_id,
    start_time: shift.start_time,
    end_time: shift.end_time,
    emp_department_id: record.emp_department_id,
    shift: shift
  };

  record[date].push(newSchedule);

  const payload = {
    record: { id: emp },
    key: [emp, date],
    date_data: record[date]
  };

  let loader = this.$loading.show({ container: this.$el });

  try {
    const res = await axios.post("/schedule/dragged-schedule-data", payload);

    await this.fetchScheduleData(this.searchData, false);

    notification.open({
      message: res.data.message,
      placement: "topRight",
      duration: process.env.VUE_APP_NOTIFICATION_DURATION,
      style: { background: process.env.VUE_APP_SUCCESS_COLOR }
    });

  } catch (error) {

    // FULL ROLLBACK
    record[date].pop();
    if (sourceRecord && sourceDate && movedSchedule) {
      sourceRecord[sourceDate].push(movedSchedule);
    }

    await this.fetchScheduleData(this.searchData, false);

    const r = error.response;
    notification.open({
      message: r?.data?.message || "Shift conflict",
      placement: "topRight",
      duration: process.env.VUE_APP_NOTIFICATION_DURATION,
      style: { background: process.env.VUE_APP_WARNING_COLOR }
    });

  } finally {
    loader.hide();
  }
},

},
computed: {
  gridTemplateColumns() {
    const employeeColumnWidth = '280px';
    const dateColumnWidth = `${this.dayWidth}px`;
    const dateColumns = this.dates.map(() => dateColumnWidth).join(' ');
    return `${employeeColumnWidth} ${dateColumns}`;
  }
}
}
</script>

<style scoped>
.shift-title{
  font-weight:600;
  font-size:14px;
}

.shift-time{
  margin-top:4px;
  font-size:12px;
  opacity:.7;
}


.palette-strip{
  position:sticky;
  top:0;
  background:#fff;
  z-index:1 !important;
  padding-bottom:12px;
}

.palette-inner{
  display:flex;
  gap:12px;
  min-width:max-content;     /* allows horizontal scroll */
}

.shift-box{
  min-width:190px;
  padding:14px;
  border-radius:12px;
  cursor:grab;
  box-shadow:0 3px 8px rgba(0,0,0,.12);
  white-space:nowrap;
}


.scheduler-table-wrapper{padding:20px;font-family:Segoe UI;--dayWidth:200px;width:100%}
.palette-fixed{
  background:#fff;
  padding-bottom:10px;
}
.shift-box{width:190px;padding:14px;border-radius:12px;cursor:grab;box-shadow:0 3px 8px rgba(0,0,0,.12)}
.scheduler-scroll{overflow-x:auto;width:100%}
.scheduler{padding:20px;font-family:Segoe UI}
.grid{display:grid;min-width:max-content;width:100%}
.cell{border-bottom:1px solid #eee;padding:12px;text-align:center}
.head{background:#fafafa;font-weight:600;border-bottom:2px solid #ddd}
.emp{text-align:left;font-weight:600}
.emp .table-avatar{display:flex;align-items:center;gap:10px;margin:0}
.emp .table-avatar .avatar{width:40px;height:40px;flex-shrink:0}
.emp .table-avatar .avatar img{width:100%;height:100%;border-radius:50%;object-fit:cover}
.emp .table-avatar a{text-decoration:none;color:inherit;font-weight:600;white-space:nowrap;font-size:14px}
.emp .table-avatar h2{margin:0;font-size:14px}
.drop-cell{min-height:70px;border:1px dashed #ddd;border-radius:8px;display:flex;flex-direction:row;flex-wrap:nowrap;gap:6px;padding:6px;align-items:stretch;overflow-x:auto}
.drop-cell:empty::after{content:"+";color:#cfcfcf;font-size:22px;display:flex;align-items:center;justify-content:center;height:70px;width:100%}
.assigned{flex:0 0 auto;min-width:180px;padding:8px 12px;border-radius:8px;font-size:12px;text-align:left;margin-bottom:0}
.assigned-title{font-weight:600}
.assigned-time{font-size:11px;opacity:.75}
</style>
